module.exports = __webpack_public_path__ + "media/stylesheets/images/register_coupon_login-fce5274ea5bd8c733753dc970a2af85a.svg";